import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=2f226577&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f226577')) {
      api.createRecord('2f226577', component.options)
    } else {
      api.reload('2f226577', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=2f226577&", function () {
      api.rerender('2f226577', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cE7ROn3Mp21S/JS/comp/childrenage.vue"
export default component.exports